module.exports = "/_next/static/images/apple-touch-icon-76-cd467376d87a53ca8fb4ab38b950942c.png";